var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTwitter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 3.75C14.3646 3.83333 14.375 3.96875 14.375 4.15625C14.375 5.26042 14.1667 6.36458 13.75 7.46875C13.3333 8.55208 12.7396 9.55208 11.9688 10.4688C11.2188 11.3646 10.2396 12.0938 9.03125 12.6562C7.82292 13.2188 6.48958 13.5 5.03125 13.5C3.19792 13.5 1.52083 13.0104 0 12.0312C0.229167 12.0521 0.489583 12.0625 0.78125 12.0625C2.30208 12.0625 3.66667 11.5938 4.875 10.6562C4.14583 10.6562 3.5 10.4479 2.9375 10.0312C2.39583 9.59375 2.02083 9.05208 1.8125 8.40625C2.02083 8.42708 2.21875 8.4375 2.40625 8.4375C2.69792 8.4375 2.98958 8.40625 3.28125 8.34375C2.78125 8.23958 2.33333 8.03125 1.9375 7.71875C1.54167 7.40625 1.22917 7.03125 1 6.59375C0.770833 6.13542 0.65625 5.64583 0.65625 5.125V5.0625C1.11458 5.33333 1.60417 5.47917 2.125 5.5C1.14583 4.83333 0.65625 3.91667 0.65625 2.75C0.65625 2.16667 0.8125 1.61458 1.125 1.09375C1.9375 2.11458 2.92708 2.92708 4.09375 3.53125C5.28125 4.13542 6.54167 4.46875 7.875 4.53125C7.83333 4.28125 7.8125 4.03125 7.8125 3.78125C7.8125 2.88542 8.125 2.11458 8.75 1.46875C9.39583 0.822917 10.1667 0.5 11.0625 0.5C12.0208 0.5 12.8229 0.84375 13.4688 1.53125C14.2188 1.38542 14.9167 1.125 15.5625 0.75C15.3125 1.52083 14.8333 2.125 14.125 2.5625C14.75 2.47917 15.375 2.30208 16 2.03125C15.5417 2.69792 14.9896 3.27083 14.3438 3.75Z",
    fill: "#333333"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/twitter.fcb1db29.svg";
export { ForwardRef as ReactComponent };